import Snackbar from './SnackbarContainer';

export default Snackbar;
